import gql from 'graphql-tag';

export default gql`
  query getMostRecentRoomForUser($userId: ID) {
    mostRecentRoomForUser(userId: $userId) {
      id
    }
  }
`;
